import { AxiosResponse } from 'axios';

import { FinishFormStatus, FormAttemptInfo } from '../../interfaces/api';
import { phpApi } from '../default';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getFormStructure: (id: number) => Promise<any> = (id: number): Promise<any> => phpApi.get(`/api/forms/${id}`);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const saveFormAnswer: (id: number, data: any) => Promise<any> = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  id: number, data: any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => phpApi.post(`/api/forms/${id}`, data);

export const finishFormAttempt: (id: number) => Promise<AxiosResponse<FinishFormStatus>> = (
  id: number
): Promise<AxiosResponse<FinishFormStatus>> => phpApi.post(`/api/forms/${id}/finish`);

export const getTypedFormStructure: (id: number) => Promise<AxiosResponse<FormAttemptInfo>> = (
  id: number
): Promise<AxiosResponse<FormAttemptInfo>> => (
  phpApi.get(`/api/forms/typed/${id}`)
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const saveAnswersInTypedForm: (id: number, data: any) => Promise<AxiosResponse<FormAttemptInfo>> = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  id: number, data: any
): Promise<AxiosResponse<FormAttemptInfo>> => (
  phpApi.post(`/api/forms/typed/${id}`, data)
);

export const generateToken: (id: number, signatureUrl: string, fieldPath?: string) => Promise<AxiosResponse<string>> = (
  id: number, signatureUrl: string, fieldPath?: string
): Promise<AxiosResponse<string>> => (
  phpApi.post(`/api/forms/${id}/token/generate-signature-verification`, {
    url: signatureUrl,
    ...(fieldPath ? { field_path: fieldPath } : {}),
  })
);

export const verifyToken: (id: number, token: string) => Promise<void> = (id: number, token: string): Promise<void> => (
  phpApi.post(`/api/forms/${id}/token/verify`, { token })
);

export const uploadFile: (id: number, fieldName: string, file: File) => Promise<AxiosResponse<string>> = (
  id: number, fieldName: string, file: File
): Promise<AxiosResponse<string>> => {
  const formData: FormData = new FormData();
  formData.append('field', fieldName);
  formData.append('file', file);

  return phpApi.post(
    `/api/forms/${id}/upload`,
    formData,
    { customEnv: { notEncryptedRequest: true } }
  );
};
